import { render } from "./BatchUpload.vue?vue&type=template&id=3bbda082&scoped=true&ts=true"
import script from "./BatchUpload.vue?vue&type=script&lang=tsx"
export * from "./BatchUpload.vue?vue&type=script&lang=tsx"

import "./BatchUpload.vue?vue&type=style&index=0&id=3bbda082&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bbda082"]])

export default __exports__